import { render, staticRenderFns } from "./shipping_bar.vue?vue&type=template&id=f4654ca4"
import script from "./shipping_bar.vue?vue&type=script&lang=js"
export * from "./shipping_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4654ca4')) {
      api.createRecord('f4654ca4', component.options)
    } else {
      api.reload('f4654ca4', component.options)
    }
    module.hot.accept("./shipping_bar.vue?vue&type=template&id=f4654ca4", function () {
      api.rerender('f4654ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/shipping_bar.vue"
export default component.exports